module.exports = __webpack_public_path__ + "static/media/morango.46a22812.png";